import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Product from "./Product";
import { fetchProduct } from "../../processes/productProcesses";
import { getProductById } from "../../selectors/productSelectors";
import { getCurrentUserId } from "../../selectors/userSelectors";

function ProductContainer(props) {
  const { dispatch, product, productId, currentUserId } = props;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (productId && !product) {
      setLoading(true);
      fetchProduct(dispatch, { userId: currentUserId, productId }).finally(() => {
        setLoading(false);
      });
    }
  }, [dispatch, product, productId]);

  return <Product {...props} loading={loading} />;
}

function mapStateToProps(state, ownProps) {
  const { productId } = ownProps.match.params;


  return {
    productId,
    product: getProductById(state, productId),
    currentUserId: getCurrentUserId(state),
  };
}

export default connect(mapStateToProps)(ProductContainer);
